export const PROJECT_TYPES = [
    "Residential Interior",
    "Commercial Interior",
    "Exterior & Facade",
    "Civil Construction",
    "Home Automation / Solar",
    "Other",
];

export const BUDGETS = ["Under ₹10 L", "₹10 – 25 L", "₹25 – 50 L", "₹50 L – 1 Cr", "Above ₹1 Cr", "Not sure yet"];

export const LEAD_STATUSES = [
    { id: "new", label: "New" },
    { id: "contacted", label: "Contacted" },
    { id: "closed", label: "Closed" },
];
